const POSTCARD_TYPES = [
  "birthday",
  "new_year",
  "mother_day",
  "doctor_day",
  "8march",
  "23february",
  "event",
  "seminar",
  "womans_well_being",
  "pharama_day",
  "doctor_congrats_1",
  "doctor_congrats_2",
];

export function postcardTypeFromPath(pathname = window.location.pathname) {
  const match = pathname.match(/\/postcard\/([^/]+)/);
  if (!match || POSTCARD_TYPES.indexOf(match[1]) === -1) return null;
  return match[1];
}

function metrikaId() {
  return window.YANDEX_METRIKA_ID;
}

export function reachGoal(goal, postcardType) {
  const id = metrikaId();
  if (!id || typeof window.ym !== "function") return;
  const params = postcardType ? { postcard_type: postcardType } : undefined;
  window.ym(id, "reachGoal", goal, params);
}

export function setVisitParams(postcardType) {
  const id = metrikaId();
  if (!id || typeof window.ym !== "function" || !postcardType) return;
  window.ym(id, "params", { postcard_type: postcardType });
}
